export default __webpack_public_path__ + "static/media/forms-orange.6eed3b1a.svg";